import {
    Extensions,
    ICustomExtensionService,
    IPluginNodeConfig,
    useTransform,
    createNode,
} from '@baidu/realtime-editor';
import type {IKuToolSDKInstance} from '../types/global';
import type {IContentExtensionInstance} from '../types/editor-extension';
import {VersionOfCreateServiceExtensionVersion} from '../constants';
import {feLogger} from '@/buried';
import {RepType} from '../types';

/**
 * 创建编辑器开放插件
 * @param store 知识库 store 对象
 */
export function createEditorExtension(store: any): IKuToolSDKInstance['editorExtension'] {
    const createServiceExtension = (
        serviceExtension: ICustomExtensionService[]
    ) => {
        const rte = store.getEditorRef().current;
        const editor = rte?.getEditorInstance?.();
        if (editor) {
            editor?.loadExtension?.({
                services: serviceExtension.map((extension) =>
                    Extensions.createService(extension)
                ),
            });
        }
    };

    return {
        createContentExtension: (contentExtension: IContentExtensionInstance[]) => {
            const rte = store.getEditorRef().current;
            const editor = rte?.getEditorInstance?.();
            if (editor) {
                editor?.loadExtension?.({
                    contents: contentExtension.map((extension) => {
                        if (
                            Array.isArray(extension.nodes) &&
                            extension.nodes.length > 0
                        ) {
                            extension.nodes = extension.nodes.map(
                                (extension: IPluginNodeConfig) =>
                                    Extensions.createViewNode(extension)
                            );
                        }

                        switch (extension.type) {
                            case 'inline':
                                // ts-ignore 暂时用 as any 处理，后续编辑器调整类型后修改
                                return Extensions.createInlinePlugin(extension as any);
                            case 'void-card':
                                // ts-ignore 暂时用 as any 处理，后续编辑器调整类型后修改
                                return Extensions.createVoidCardPlugin(extension as any);
                            default:
                                return Extensions.createCardPlugin(extension);
                        }
                    }),
                });
            }
        },
        createServiceExtension: (serviceExtension: ICustomExtensionService[]) => {
            createServiceExtension(serviceExtension);
        },
        createServiceExtensionWithVersion: (
            version: string,
            serviceExtension: ICustomExtensionService[]
        ) => {
            if (!version || !VersionOfCreateServiceExtensionVersion) {
                return;
            }
            if (Number(VersionOfCreateServiceExtensionVersion) < Number(version)) {
                feLogger({
                    rep_id: '80001.2.366',
                    rep_type: RepType.Show,
                    rep_params: {
                        hostVersion: VersionOfCreateServiceExtensionVersion,
                        sdkVersion: version,
                    },
                });
                return;
            }
            createServiceExtension(serviceExtension);
        },
        useTransform,
        createNode,
    };
}
